import React from 'react';
import { Typography } from 'antd';
import classNames from 'classnames';

const { Text } = Typography;

type FontSizeType = 'small' | 'middle' | 'big';

interface CustomTextProps {
  text?: string;
  strong?: boolean;
  inline?: boolean;
  fontSize?: FontSizeType;
  centered?: boolean; // Nuevo prop para centrar
  customClass?: string
}

const CustomText: React.FC<CustomTextProps> = ({
  text,
  strong,
  inline,
  fontSize = 'middle',
  centered = false,
  customClass
}) => {
  const computedFontSize = (() => {
    switch (fontSize) {
      case 'small':
        return '14px';
      case 'big':
        return '18px';
      case 'middle':
      default:
        return '16px';
    }
  })();
  /* const capitalizeFirstLetter = (text?: string): string => {
    if (!text) return '';
    const lower = text.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }; */

  return (
    <Text
      className={classNames('custom-label',{
        'custom-text-inline': inline,
        'custom-text-block': !inline,
        
      }, customClass)}
      strong={strong}
      style={{
        fontSize: computedFontSize,
        textAlign: centered ? 'center' : undefined,
        display: inline ? 'inline' : 'block',
      }}
    >
      {text || 'No especificado'}
    </Text>
  );
};

export default CustomText;
